/* tslint:disable */
/* eslint-disable */
/**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    RuntimeBlock,
    RuntimeBlockFromJSON,
    RuntimeBlockFromJSONTyped,
    RuntimeBlockToJSON,
} from './';

/**
 * A list of consensus blocks.
 * @export
 * @interface RuntimeBlockListAllOf
 */
export interface RuntimeBlockListAllOf {
    /**
     * 
     * @type {Array<RuntimeBlock>}
     * @memberof RuntimeBlockListAllOf
     */
    blocks: Array<RuntimeBlock>;
}

export function RuntimeBlockListAllOfFromJSON(json: any): RuntimeBlockListAllOf {
    return RuntimeBlockListAllOfFromJSONTyped(json, false);
}

export function RuntimeBlockListAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): RuntimeBlockListAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'blocks': ((json['blocks'] as Array<any>).map(RuntimeBlockFromJSON)),
    };
}

export function RuntimeBlockListAllOfToJSON(value?: RuntimeBlockListAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'blocks': ((value.blocks as Array<any>).map(RuntimeBlockToJSON)),
    };
}


